import { sendRequest } from 'best-modules/vue-utils'
import { Query } from 'best-modules/utils'
import { PaginationList } from 'best-modules/components/server-table/types'
import {
  RegistrationJournal,
  RegistrationJournalCredentials,
  RegistrationJournalDefinition,
} from '@/utils/types/registrationJournal'

const registrationJournalList = (
  query: Query
): Promise<PaginationList<RegistrationJournal>> => {
  return sendRequest({
    name: 'registrationJournalList',
    method: 'get',
    url: {
      url: '/json/doc-type/journal',
      query,
    },
  })
}

const registrationJournalCreate = (
  credentials: RegistrationJournalCredentials
): Promise<RegistrationJournal> => {
  return sendRequest({
    name: 'registrationJournalCreate',
    method: 'post',
    url: '/json/doc-type/journal/create',
    payload: credentials,
  })
}

const registrationJournalUpdate = (
  id: number,
  credentials: RegistrationJournalCredentials
): Promise<RegistrationJournal> => {
  return sendRequest({
    name: 'registrationJournalUpdate',
    method: 'put',
    url: `/json/doc-type/journal/update/${id}`,
    payload: credentials,
  })
}

const registrationJournalSingle = (
  id: number
): Promise<RegistrationJournal> => {
  return sendRequest({
    name: 'registrationJournalSingle',
    method: 'get',
    url: `/json/doc-type/journal/single/${id}`,
  })
}

const registrationJournalActivate = (
  id: number
): Promise<RegistrationJournal> => {
  return sendRequest({
    name: 'registrationJournalActivate',
    method: 'get',
    url: `/json/doc-type/journal/activate/${id}`,
  })
}

const registrationJournalDeactivate = (
  id: number
): Promise<RegistrationJournal> => {
  return sendRequest({
    name: 'registrationJournalDeactivate',
    method: 'get',
    url: `/json/doc-type/journal/deactivate/${id}`,
  })
}

const registrationJournalDelete = (
  id: number
): Promise<RegistrationJournal> => {
  return sendRequest({
    name: 'registrationJournalDelete',
    method: 'delete',
    url: `/json/doc-type/journal/delete/${id}`,
  })
}

const registrationJournalMaskCreate = (
  id: number,
  credentials: RegistrationJournalCredentials
): Promise<RegistrationJournal> => {
  return sendRequest({
    name: 'registrationJournalMaskCreate',
    method: 'post',
    url: `/json/doc-type/journal/mask/create/${id}`,
    payload: credentials,
  })
}

const registrationJournalMaskDelete = (
  id: number
): Promise<RegistrationJournal> => {
  return sendRequest({
    name: 'registrationJournalMaskDelete',
    method: 'delete',
    url: `/json/doc-type/journal/mask/delete/${id}`,
  })
}

const registrationJournalsByDefinition = (
  docTypeDefinitionId: number
): Promise<RegistrationJournalDefinition[]> => {
  return sendRequest({
    name: 'registrationJournalsByDefinition',
    method: 'get',
    url: `/json/list/registrationJournalsByDefinition/${docTypeDefinitionId}`,
  })
}

const registrationJournalDefinitionCreate = (
  journalId: number,
  docTypeDefinitionId: number
): Promise<RegistrationJournal> => {
  return sendRequest({
    name: 'registrationJournalDefinitionCreate',
    method: 'post',
    url: `/json/doc-type/journal/doc-type-definition/add/${journalId}/${docTypeDefinitionId}`,
  })
}

const registrationJournalDefinitionDelete = (
  journalId: number,
  docTypeDefinitionId: number
): Promise<RegistrationJournal> => {
  return sendRequest({
    name: 'registrationJournalDefinitionDelete',
    method: 'delete',
    url: `/json/doc-type/journal/doc-type-definition/remove/${journalId}/${docTypeDefinitionId}`,
  })
}

const registrationJournalDepartmentCreate = (
  journalId: number,
  departmentId: number
): Promise<RegistrationJournal> => {
  return sendRequest({
    name: 'registrationJournalDepartmentCreate',
    method: 'post',
    url: `/json/doc-type/journal/department/add/${journalId}/${departmentId}`,
  })
}

const registrationJournalDepartmentDelete = (
  journalId: number,
  departmentId: number
): Promise<RegistrationJournal> => {
  return sendRequest({
    name: 'registrationJournalDepartmentDelete',
    method: 'delete',
    url: `/json/doc-type/journal/department/remove/${journalId}/${departmentId}`,
  })
}

const registrationJournalUserCreate = (
  journalId: number,
  userId: number
): Promise<RegistrationJournal> => {
  return sendRequest({
    name: 'registrationJournalUserCreate',
    method: 'post',
    url: `/json/doc-type/journal/user/add/${journalId}/${userId}`,
  })
}

const registrationJournalUserDelete = (
  journalId: number,
  userId: number
): Promise<RegistrationJournal> => {
  return sendRequest({
    name: `registrationJournalUserDelete_${userId}`,
    method: 'delete',
    url: `/json/doc-type/journal/user/remove/${journalId}/${userId}`,
  })
}

export {
  registrationJournalList,
  registrationJournalCreate,
  registrationJournalUpdate,
  registrationJournalSingle,
  registrationJournalActivate,
  registrationJournalDeactivate,
  registrationJournalDelete,
  registrationJournalMaskCreate,
  registrationJournalMaskDelete,
  registrationJournalsByDefinition,
  registrationJournalDefinitionCreate,
  registrationJournalDefinitionDelete,
  registrationJournalDepartmentCreate,
  registrationJournalDepartmentDelete,
  registrationJournalUserCreate,
  registrationJournalUserDelete,
}
